import React from "react";

export const RejectNoteSvg = () => {
  return (
    <div>
      <svg
        width="55"
        height="57"
        viewBox="0 0 55 57"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x=".1"
          y=".333"
          width="54.8"
          height="56"
          rx="27.4"
          fill="#FEF3F2"
        />
        <path
          d="M32.3 16.334v2.4m-6-2.4v2.4m-6-2.4v2.4m16.2 10.2v-3c0-3.96 0-5.94-1.23-7.17s-3.21-1.23-7.17-1.23h-3.6c-3.96 0-5.94 0-7.17 1.23s-1.23 3.21-1.23 7.17v6c0 3.96 0 5.94 1.23 7.17s3.21 1.23 7.17 1.23h2.4m12-8.4-4.2 4.2m0 0-4.2 4.2m4.2-4.2 4.2 4.2m-4.2-4.2-4.2-4.2m-9 0h4.8m-4.8-6h9.6"
          stroke="#D92D20"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
